var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ListenButton"},[_c('div',{staticClass:"Button",on:{"click":function($event){return _vm.onClick()}}},[_vm._v(_vm._s(_vm.trans('GLOBAL.listen')))])])}
var staticRenderFns = []

export { render, staticRenderFns }